
import { FilterCommonEventType, FilterType } from '../enums';
import FilterListingStatus from '../listing-status';
import FilterListingType from '../listing-type';
import FilterRangeFinishedArea from '../range-finished-area';
import FilterRangeLandSize from '../range-land-size';
import FilterRangeYearBuilt from '../range-year-built';
import { StyleColorSchemeType, StyleSizeType } from '../../../ui-kit/styles/enums';

export default {
  name: 'FilterFactory',
  props: {
    filterType: {
      default: '',
      type: String,
    },
    value: {
      default: () => [],
      type: [Array, Object],
    },
    checkboxIconSize: {
      default: StyleSizeType.Medium,
      type: String,
    },
    colorScheme: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    iconColor: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    filterComponent() {
      switch (this.filterType) {
        case FilterType.ListingStatus:
          return FilterListingStatus;
        case FilterType.FinishedArea:
          return FilterRangeFinishedArea;
        case FilterType.LandSize:
          return FilterRangeLandSize;
        case FilterType.YearBuilt:
          return FilterRangeYearBuilt;
        case FilterType.ListingType:
        default:
          return FilterListingType;
      }
    },
  },
  methods: {
    handleChange(value) {
      this.$emit(FilterCommonEventType.Change, { key: this.filterType, value });
    },
  },
};
